/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_No_ExpirationInputs */

const en_carrier_notices_no_expiration = /** @type {(inputs: Carrier_Notices_No_ExpirationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No expiration`)
};

const es_carrier_notices_no_expiration = /** @type {(inputs: Carrier_Notices_No_ExpirationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin vencimiento`)
};

/**
* | output |
* | --- |
* | "No expiration" |
*
* @param {Carrier_Notices_No_ExpirationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_no_expiration = /** @type {((inputs?: Carrier_Notices_No_ExpirationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_No_ExpirationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_no_expiration(inputs)
	return es_carrier_notices_no_expiration(inputs)
});